<div class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3  class="h6 mb-0">Technical Support</h3>
      <button  type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->
  <div style="position: relative">

    <div class="card-body" >
      <div class="alert alert-warning">Please look over these common solutions and if you don't see your answer, then please chat our team.</div>

      <div class="participant-list">
        <div>

          <ul class="text-prechat">
            <li>
              <div class="d-block">Stream is not playing</div>
              Most of the time a simple <a href="javascript:void(0)" (click)="refresh()">refresh</a> of your browser will fix this. Sometimes you need to click the play icon on the video player. You can also try <a href="javascript:void(0)" (click)="toggleCompatibility()">compatibily mode</a> if that doesn't work!
            </li>
            <li>
              <div class="d-block">How do I get CEUs</div>
              Click 3 out of the 4 attendance checks that show randomly throughout. Once the event is over, you can add a review and get your certificate in
              <a *ngIf="event.conferenceId" target="_blank" [routerLink]="['/account/ceus/conference-ceus', event.conferenceId, 'event-summaries']">CEU History</a>
              <a *ngIf="!event.conferenceId" target="_blank" [routerLink]="['/account/ceus/individual-ceus', event.id]">CEU History</a>
            </li>
            <li>
              <div class="d-block">I missed a CEU check</div>
              No worries! You need 3 out of 4 checks to pass, but If you are here, you will get CEUs. You can resolve problems AFTER the event in
              <a *ngIf="event.conferenceId" target="_blank" [routerLink]="['/account/ceus/conference-ceus', event.conferenceId, 'event-summaries']">CEU History</a>
              <a *ngIf="!event.conferenceId" target="_blank" [routerLink]="['/account/ceus/individual-ceus', event.id]">CEU History</a>
            </li>
            <li>
              <div class="d-block">Add BACB #</div>
              If you haven't yet, you can add your BACB number in
              <a target="_blank" [routerLink]="['/account/ceus/certifications']"> My Account</a>
            </li>
          </ul>
        </div>
      </div>
    </div>


    <!-- Footer -->
    <div class="card-footer d-flex justify-content-end" >
      <div class="input-group d-flex justify-content-around" >
        <button type="button" (click)="supportChat()" class="btn btn-admin-primary btn-sm">Chat our team</button>
      </div>

    </div>

  </div>
  <!-- End Footer -->
</div>
